import { defaultTheme, SingleSelectTheme } from '@medly-components/theme';

import colors from './colors';

export const singleSelect: SingleSelectTheme = {
    ...defaultTheme.singleSelect,
    variant: {
        // outlined, filled, & fusion variant theme is coming from textField
        flat: {
            ...defaultTheme.singleSelect.variant.flat,
            valueColor: {
                default: colors.coral[500],
                hovered: colors.coral[600],
                pressed: colors.coral[700],
                activated: colors.coral[500],
                disabled: colors.grey[400],
                error: colors.red[500]
            }
        }
    },
    option: {
        ...defaultTheme.singleSelect.option,
        bgColor: {
            default: colors.white,
            hovered: colors.grey[200],
            pressed: colors.grey[100],
            selected: colors.grey[200],
            error: colors.red[100]
        },
        textColor: {
            default: colors.darkBlue,
            hovered: colors.darkBlue,
            selected: colors.darkBlue,
            error: colors.error,
            disabled: colors.grey[500]
        }
    }
};
